/**
 * You can register global mixins here
 */

const GlobalMixins = {
  install(Vue) {}
};

export default GlobalMixins;
